<template>
  <!-- -->
  <div class="view1">
    <div class="left">
      <div class="top border">
        <div style="margin-top: -10px">
          <span class="title">快捷操作</span>
        </div>
        <div class="short-sty">
          <div class="container">
            <div class="layout">
              <div v-for="(item, index) in shortcutList" :key="index.id" class="short-info"
                @click="$routerUtil.push(item.routerPush)">
                <div>
                  <el-image style="width: 50px;border-radius: 7px" :src="item.url" fit="fill" />
                </div>
                <div class="text">{{ item.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="center">
        <div class="border" style="height: 100%">
          <div class="content-info">
            <div class="left-area">
              <span class="title">销售数据</span>
              <date-range v-model:start-time="orderCountInfo.startTime" v-model:end-time="orderCountInfo.endTime"
                @change="queryOrderCount" />
            </div>
            <div style="display: flex; align-items: center;">
              <el-select v-model="orderCountInfo.stockId" placeholder="全部仓库" clearable @change="queryOrderCount">
                <el-option v-for="item in stockList" :key="item.id" :label="item.stockName" :value="item.id" />
              </el-select>
            </div>
          </div>
          <div class="order-count-div">
            <div v-for="(o, i) in orderColumns" :key="i" @click="$routerUtil.push(`/plat/order`)" class="stat-card">
              <div class="card-content">
                <div class="stat-label">{{ o.label }}</div>
                <div class="stat-value">
                  <money :value="orderStatisticInfo[o.column]" v-if="o.type === 'money'" />
                  <span v-else>{{ orderStatisticInfo[o.column] || 0 }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom border">
        <div class="content-info">
          <div class="left-area">
            <span class="title">库存预警</span>
            <span class="span-btn" :class="{ on: !searchInfo.stockId }" @click="resetWarningSearch('')">
              查看全部
            </span>
          </div>
          <div>
            <el-select v-model="searchInfo.stockId" placeholder="全部仓库" clearable @change="resetWarningSearch">
              <el-option v-for="item in stockList" :key="item.id" :label="item.stockName" :value="item.id" />
            </el-select>
          </div>
        </div>
        <div style="height: 528px; box-sizing: border-box;" id="stockWarning">
          <el-table stripe :data="dataList" height="100%" :align="'center'">
            <el-table-column :align="'center'" label="序号" width="60px" type="index" />
            <el-table-column :align="'center'" label="仓库" prop="stockName" show-overflow-tooltip />
            <el-table-column :align="'center'" label="商品名称" prop="skuName" show-overflow-tooltip />
            <el-table-column :align="'center'" label="库存量" prop="skuQty" show-overflow-tooltip />
            <el-table-column :align="'center'" label="下限预警值" prop="warnMin" show-overflow-tooltip />
            <el-table-column :align="'center'" label="上限预警值" prop="warnMax" show-overflow-tooltip />
          </el-table>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="top border">
        <div class="title">用户信息</div>
        <div class="user-info">
          <div class="name">登录用户</div>
          <div>{{ userInfo.userName }}</div>
        </div>
        <div class="user-info">
          <div class="name">所属部门</div>
          <div>{{ userInfo.mainDepartName }}</div>
        </div>
        <div class="user-info">
          <div class="name">所属机构</div>
          <div>{{ userInfo.merchantName }}</div>
        </div>
      </div>
      <div class="bottom">
        <div class="border" style="height: 100%">
          <div class="title">更新记录</div>
          <div class="document-list">
            <a target="_blank" v-for="(r, i) in updateRecordList" :key="i" :href="r.docUrl">
              {{ r.versionName }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import commonApi from "@/api/commonApi";
import DateRange from "@/components/h5/date/DateRange.vue";
import Money from "@/components/h5/Money.vue";
import util from "@/util/util";
import stockApi from "@/api/main/stock/stockApi";
export default {
  name: "HomeView",
  components: { DateRange, Money },
  data() {
    return {
      stockList: [],
      dataList: [],
      searchInfo: {
        stockId: "",
        stockName: "全部",
        pageNumber: 1,
        pageSize: 10,
      },
      shortcutList: [
        {
          id: 1,
          name: '销售订单',
          url: require(`../../../assets/image/h5/home/收银流水.png`),
          routerPush: `/report/offline-order`,
        },
        {
          id: 2,
          name: '日结报表',
          url: require(`../../../assets/image/h5/home/功能图标/日结报表.png`),
          routerPush: `/plat/dailySettle`,
        },
        {
          id: 3,
          name: '客户档案',
          url: require(`../../../assets/image/h5/home/功能图标/客户档案.png`),
          routerPush: `/customer/member`,
        },
        {
          id: 4,
          name: '押金管理',
          url: require(`../../../assets/image/h5/home/功能图标/费用管理.png`),
          routerPush: `/advance/list`,
        },
        {
          id: 5,
          name: '商品档案',
          url: require(`../../../assets/image/h5/home/功能图标/商品档案.png`),
          routerPush: `/product/list`,
        },
        {
          id: 6,
          name: '库存查询',
          url: require(`../../../assets/image/h5/home/功能图标/库存查询.png`),
          routerPush: `/stock/product`,
        },
      ],
      stockWarningHeight: "200px",
      // 销售数据统计的参数
      orderCountInfo: {},
      orderStatisticInfo: {},
      orderCountType: "today",
      orderColumns: [{ label: "订单单数", column: "orderCount" }, { label: "订单金额", column: "orderAmount", type: "money" }, { label: "退单单数", column: "refundCount" }, { label: "退单金额", column: "refundAmount", type: "money" },],
      userInfo: {},
      updateRecordList: [],
    };
  },
  created() {
    // 查询版本信息
    commonApi.queryVersionInfo().then(list => {
      let arr = [];
      for (let i = 0; i < list.length; i++) {
        if (list[i].type === "1") {
          arr.push(list[i]);
        }
      }
      this.updateRecordList = arr;
    })
    stockApi.queryListByNotCondition().then(list => this.stockList = list)
    // commonApi.queryAllStock().then(list =>  this.stockList = list);
    this.queryWarnList();
    // 销售订单统计时间
    this.orderCountInfo.startTime = new Date(new Date().getTime()).format("yyyy-MM-dd") + " 00:00:00";
    this.orderCountInfo.endTime = new Date().format("yyyy-MM-dd") + " 23:59:59";
    // 获取登录用户信息
    util.getUserInfo().then(res => {
      this.userInfo = res;
    });
    // 初始化该账号的默认仓库,并查询信息
    this.initStock();
  },
  mounted() {
    this.stockWarningHeight = document.querySelector("#stockWarning").clientHeight + 'px';
  },
  methods: {
    // 初始化默认仓库
    async initStock() {
      const userInfo = await util.getUserInfo();
      if (userInfo.mainDepartCode) {
        const stockList = await commonApi.findByDepartId(userInfo.mainDepartId);
        this.orderCountInfo.stockId = stockList[0].id;
        await this.queryOrderCount();
      }
    },
    resetWarningSearch(val) {
      this.searchInfo.stockId = val;
      this.queryWarnList();
    },
    queryWarnList() {
      commonApi.queryWarningList(this.searchInfo).then(res => {
        this.dataList = res.records;
      })
    },
    queryOrderCount() {
      commonApi.querySaleStatisticInfo(this.orderCountInfo).then(data => this.orderStatisticInfo = data || {});
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/components/dialog";

@import "@/assets/css/components/table";

.view1 {
  background: none;
  border: none;
  height: calc(100vh - 100px);
  overflow: scroll;
  position: relative;

  .left {
    width: calc(100% - 305px);
    box-sizing: border-box;
    padding-right: 10px;
    height: 100%;

    .top {
      height: 200px;
      box-sizing: border-box;

      .short-sty {
        height: calc(100% - 60px);
        padding: 0 60px;
        overflow: hidden;
        position: relative;

        .container {
          position: relative;
          overflow: hidden;
          height: 100%;
          overflow-x: auto;

          // 美化滚动条
          &::-webkit-scrollbar {
            height: 4px;
          }

          &::-webkit-scrollbar-thumb {
            background: rgba(0, 0, 0, 0.1);
            border-radius: 4px;
          }

          &::-webkit-scrollbar-track {
            background: rgba(0, 0, 0, 0.02);
          }

          .layout {
            white-space: nowrap;
            position: absolute;
            height: 0px;
            top: 50%;
            width: 100%;

            .short-info {
              margin-right: 50px;
              margin-top: -45px;
              text-align: center;
              display: inline-block;
              cursor: pointer;
              transition: all 0.3s ease;

              &:hover {
                transform: translateY(-3px);

                .el-image {
                  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
                  transform: translateY(-2px);
                }

                .text {
                  color: #409EFF;
                }
              }

              .el-image {
                width: 56px !important;
                height: 56px !important;
                border-radius: 16px !important;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
                transition: all 0.3s ease;
                background: #fff;
                padding: 12px;
                box-sizing: border-box;
              }

              .text {
                font-size: 13px;
                margin-top: 12px;
                color: #606266;
                font-weight: 500;
                transition: color 0.3s ease;
              }

              &:last-child {
                margin-right: 0;
              }
            }
          }
        }
      }

      .title {
        position: relative;
        padding-left: 12px;
        margin-top: -10px;

        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 3px;
          height: 16px;
          background: #409EFF;
          border-radius: 2px;
        }
      }
    }

    .center {
      height: 260px;
      box-sizing: border-box;
      padding: 10px 0;

      .content-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        padding: 0 4px;

        .left-area {
          display: flex;
          align-items: center;

          .title {
            position: relative;
            padding-left: 12px;
            line-height: 40px;
            font-size: 16px;
            font-weight: 600;
            margin-right: 16px;

            &::before {
              content: '';
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 3px;
              height: 16px;
              background: #409EFF;
              border-radius: 2px;
            }
          }

          :deep(.date-range) {
            .el-input__wrapper {
              border-radius: 8px;
              box-shadow: 0 0 0 1px #DCDFE6;
              transition: all 0.3s;

              &:hover {
                box-shadow: 0 0 0 1px #409EFF;
              }
            }
          }
        }

        :deep(.el-select) {
          width: 200px;

          .el-input__wrapper {
            border-radius: 8px;
            box-shadow: 0 0 0 1px #DCDFE6;
            transition: all 0.3s;

            &:hover {
              box-shadow: 0 0 0 1px #409EFF;
            }
          }
        }
      }

      .order-count-div {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 20px;
        padding: 16px;
        
        .stat-card {
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          cursor: pointer;
          position: relative;
          overflow: hidden;
          
          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 4px;
            background: linear-gradient(90deg, #409EFF, #67C23A);
            opacity: 0;
            transition: opacity 0.3s ease;
          }
          
          &:hover {
            transform: translateY(-4px);
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
            
            &::before {
              opacity: 1;
            }
          }
          
          .card-content {
            padding: 20px;
            display: flex;
            flex-direction: column;
            gap: 12px;
            
            .stat-label {
              color: #606266;
              font-size: 14px;
              font-weight: 500;
            }
            
            .stat-value {
              font-size: 24px;
              font-weight: 600;
              color: #303133;
              
              // 金额样式
              :deep(.money) {
                color: #F56C6C;
                
                &::before {
                  content: '¥';
                  font-size: 16px;
                  margin-right: 4px;
                }
              }
            }
          }
        }
      }
    }

    .bottom {
      .content-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        padding: 0 4px;

        .left-area {
          display: flex;
          align-items: center;

          .title {
            position: relative;
            padding-left: 12px;
            line-height: 40px;
            font-size: 16px;
            font-weight: 600;
            margin-right: 16px;

            &::before {
              content: '';
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 3px;
              height: 16px;
              background: #409EFF;
              border-radius: 2px;
            }
          }

          .span-btn {
            font-size: 13px;
            color: #909399;
            margin-left: 16px;
            cursor: pointer;
            transition: all 0.3s;
            user-select: none;

            &.on {
              color: #409EFF;
              font-weight: 500;
            }

            &:hover {
              color: #409EFF;
            }
          }
        }

        :deep(.el-select) {
          width: 200px;

          .el-input__wrapper {
            border-radius: 8px;
            box-shadow: 0 0 0 1px #DCDFE6;
            transition: all 0.3s;

            &:hover {
              box-shadow: 0 0 0 1px #409EFF;
            }
          }
        }
      }

      :deep(.el-table) {
        border-radius: 8px;
        overflow: hidden;

        // 表头样式
        .el-table__header {
          th {
            background-color: #F5F7FA !important;
            color: #606266;
            font-weight: 600;
            height: 50px;
            padding: 8px 0;
          }
        }

        // 表格内容
        .el-table__body {
          td {
            padding: 12px 0;
            color: #606266;
          }
        }

        // 斑马纹颜色
        .el-table__row--striped td {
          background-color: #FAFAFA;
        }

        // 鼠标悬浮效果
        .el-table__body tr:hover>td {
          background-color: #F5F7FA;
        }

        // 滚动条样式
        .el-scrollbar__bar {
          &.is-horizontal {
            height: 8px;
          }

          &.is-vertical {
            width: 8px;
          }
        }
      }
    }
  }

  .right {
    width: 300px;
    height: calc(100vh - 116px);
    position: fixed;
    right: 22px;
    top: 94px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .top {
      height: auto;
      min-height: 200px;

      .title {
        position: relative;
        padding-left: 12px;
        margin: 0 0 16px;
        line-height: 40px;
        font-size: 16px;
        font-weight: 600;

        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 3px;
          height: 16px;
          background: #409EFF;
          border-radius: 2px;
        }
      }

      .user-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 8px;
        margin: 0;
        border-bottom: 1px solid #f0f0f0;
        transition: all 0.3s ease;

        &:hover {
          background: #f9fafc;
        }

        .name {
          color: #909399;
          font-size: 13px;
        }

        div:last-child {
          color: #303133;
          font-size: 13px;
          font-weight: 500;
        }

        &:last-child {
          border-bottom: none;
        }
      }
    }

    .bottom {
      flex: 1;
      min-height: 180px;
      margin-bottom: 10px;

      .border {
        height: 100%;
        display: flex;
        flex-direction: column;
      }

      .title {
        position: relative;
        padding-left: 12px;
        margin: 0 0 16px;
        line-height: 40px;
        font-size: 16px;
        font-weight: 600;

        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 3px;
          height: 16px;
          background: #409EFF;
          border-radius: 2px;
        }
      }

      .document-list {
        flex: 1;
        overflow-y: auto;
        padding: 0 8px;

        &::-webkit-scrollbar {
          width: 4px;
        }

        &::-webkit-scrollbar-thumb {
          background: rgba(0, 0, 0, 0.1);
          border-radius: 4px;
        }

        a {
          display: block;
          color: #606266;
          font-size: 13px;
          text-decoration: none;
          padding: 8px 0;
          padding-left: 16px;
          border-bottom: 1px solid #f0f0f0;
          transition: all 0.3s ease;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          position: relative;

          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background: #DCDFE6;
            transition: all 0.3s ease;
          }

          &:hover {
            color: #409EFF;
            padding-left: 20px;

            &::before {
              background: #409EFF;
              width: 6px;
              height: 6px;
            }
          }

          &:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }

  .border {
    border: 1px solid #EBEEF5;
    border-radius: 8px;
    background: #FFF;
    padding: 16px;
    box-sizing: border-box;
    transition: all 0.3s ease;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.03);

    &:hover {
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
    }
  }

  .title {
    font-size: 16px;
    font-weight: 600;
    line-height: 60px;
  }
}

.el-dropdown,
.el-dropdown * {
  outline: none;
}

.el-tooltip__trigger {
  margin-top: 24px;
  color: blue;
  font-size: 11px !important;
  text-decoration: underline;

  .el-icon {
    font-size: 11px !important;
    color: blue;
  }
}

.content-info {
  display: flex;
  justify-content: space-between;
  line-height: 40px;
  margin-bottom: 10px;

  .title {
    line-height: 40px;
  }

  .span-btn {
    margin-left: 10px;
    font-size: 12px;
    color: #999;
    user-select: none;
    cursor: pointer;
  }

  .span-btn.on {
    color: #409EFF;
  }

  :deep(.el-select) {
    width: 240px;
  }
}

.order-count-div {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  padding: 16px;
  
  .stat-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;
    position: relative;
    overflow: hidden;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 4px;
      background: linear-gradient(90deg, #409EFF, #67C23A);
      opacity: 0;
      transition: opacity 0.3s ease;
    }
    
    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
      
      &::before {
        opacity: 1;
      }
    }
    
    .card-content {
      padding: 20px;
      display: flex;
      flex-direction: column;
      gap: 12px;
      
      .stat-label {
        color: #606266;
        font-size: 14px;
        font-weight: 500;
      }
      
      .stat-value {
        font-size: 24px;
        font-weight: 600;
        color: #303133;
        
        // 金额样式
        :deep(.money) {
          color: #F56C6C;
          
          &::before {
            content: '¥';
            font-size: 16px;
            margin-right: 4px;
          }
        }
      }
    }
  }
}

// 响应式调整
@media screen and (max-width: 768px) {
  .order-count-div {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    padding: 12px;
    
    .stat-card {
      .card-content {
        padding: 16px;
        
        .stat-label {
          font-size: 13px;
        }
        
        .stat-value {
          font-size: 20px;
        }
      }
    }
  }
}

.user-info {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #dddfe7;
  font-size: 14px;
  margin: 10px 10px;
  line-height: 30px;

  .name {
    color: #999;
  }
}

.document-list {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  line-height: 40px;
  border-bottom: 1px solid #dddfe7;
  height: 36px;

  a {
    color: #409eff;
    font-size: 14px;
    text-decoration: auto;
  }
}

@media (max-height: 1200px) {}

@media (max-height: 800px) {
  .content-info {
    :deep(.el-select) {
      width: 200px;
    }

    .date-range {
      width: 450px;
    }
  }

  .order-count-div>div {
    .blank {
      height: 20px;
    }

    .order-info {
      height: auto;

      .name {
        height: auto;
      }
    }
  }

  .user-info {}

  .view1 .right {
    .top {}

    .bottom {}
  }
}

@import "@/assets/css/el-tables";
</style>
